import axios from "axios";

import { API } from "../App";

/** GET /api/profile/disclaimer — the yaml sentence, not an i18n paraphrase. */
export async function fetchDisclaimer(locale) {
  const query = encodeURIComponent(locale || "");
  const res = await axios.get(`${API}/profile/disclaimer?locale=${query}`);
  const data = res.data?.data || {};
  return {
    text: typeof data.text === "string" ? data.text : "",
    text_version: typeof data.text_version === "string" ? data.text_version : "",
    locale: typeof data.locale === "string" ? data.locale : locale,
  };
}

/** POST /api/profile/disclaimer. Platform is web for this client. */
export async function postDisclaimerConsent({ text_version, platform, locale }) {
  const res = await axios.post(`${API}/profile/disclaimer`, {
    text_version,
    platform,
    locale,
  });
  return res.data?.data || {};
}
